// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .chip  > button{\n  background: transparent;\n}[dir=ltr] .chip  > button{\n  margin-left: 4px;\n}[dir=rtl] .chip  > button{\n  margin-right: 4px;\n}\n.chip  > button > i {\n  color: white;\n}\n@media only screen and (min-width: 1700px)  {\n.responsiveInputs {\n    width: 50%;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
